export const tooltipData = {
  studyInfo_studySettings: {
    value:
      'Only the selected fields of business information will be screened in the automated Keyword Screening step.\nThe selected fields of business information will be displayed on the Business Description Review tab by default but you can add additional columns by clicking the three dots icon in the header to the far left of the grid.',
  },
  keywordScreening_extractKeyWords: {
    value:
      'Only the selected fields of business information will be screened in the automated Keyword Screening step.\nThe selected fields of business information will be displayed on the Business Description Review tab by default but you can add additional columns by clicking the three dots icon in the header to the far left of the grid.',
  },
  studyInfo_31Alignment: {
    value:
      'It is the default setting by Bureau van Dijk. Searches and displays on yearly data relating to Year t include companies with fiscal year-ends through March 31 of Year t+1.',
  },
  studyInfo_5_7Alignment: {
    value:
      'It aligns with a tested party’s fiscal year-end based on a X months back and 12-X months forward rule. E.g. 7 months back is given by default, companies having a fiscal year-end between 7 months before and 5 months after the provided tested party’s fiscal year-end will be included.',
  },
  ratio_ROA: {
    value: 'Operating Profit divided by Total Assets',
  },
  ratio_BR: {
    value: 'Gross Profit divided by Operating Expenses',
  },
  ratio_GM: {
    value: 'Gross Profit divided by turnover',
  },
  ratio_NCP: {
    value: 'Operating profit/loss divided by turnover minus Operating profit/loss. It is also known as "Markup on Total Costs".',
  },
  ratio_OM: {
    value: 'Operating profit/loss divided by Turnover',
  },
  'ratio_GM(A)': {
    value: 'Material costs is used as a proxy of COGS (Turnover minus material costs divided by turnover minus material costs minus operating P/L)',
  },
  ratio_ROIC: {
    value: 'Operating Income divided by Average Invested Capital',
  },
  ratio_GCP: {
    value: 'Gross cost plus = Gross profit / Cost of goods sold',
  },
  'ratio_GCP(A)': {
    value: 'Gross cost plus (Alternative) = Gross profit / Material cost',
  },
  ratio_ROLTA: {
    value: 'Operating Income divided by Total Assets minus Total Current Assets',
  },
  ratio_ROCE: {
    value: 'Operating Income divided by Total Assets minus Total Current Liabilities',
  },
  ratio_MROA: {
    value: 'Operating Profit divide by Total Assets-Intangible Assets-Permanent Investments',
  },
  studyInfo_averageMethod_1: {
    value:
      'An average value is calculated for each company in the set. It is computed as the sum of the individual data points (e.g. operating margin) divided by the number of the data points. It is also called arithmetic average.',
  },
  studyInfo_averageMethod_2: {
    value:
      'An average value is calculated for each company in the set. It is defined as the ratio of the sums of relevant P&L item (e.g. operating profit) to the relevant base (e.g. operating revenue, total costs) over several tax periods (years).',
  },
  studyInfo_averageMethod_3: {
    value: 'Under the pooling method, each data point represents one observation from which to construct the interquartile range.',
  },
  studyInfo_interquartileMethod_1: {
    value:
      'IRS defined quartile calculation is also called EY quartile. If the quartile falls between two numbers, take the average of the two numbers.',
  },
  studyInfo_interquartileMethod_2: {
    value:
      'Quartile.Inc function bases its calculation on a percentile range of 0 to 1 inclusive, whereas the Quartile.Exc function bases its calculation on a percentile range of 0 to 1 exclusive.',
  },
  studyInfo_worldRegions: {
    value:
      'It labels the type of the study you are performing (e.g. pan-European, pan-Asian studies). You still need to add geographic location filter for regions or countries in the search strategy.',
  },
  testedPartyInfo_worldRegions: {
    value:
      'It specifies the geographical location(s) of the tested party or parties. However, you still need to add geographic location filter for regions or countries in the search strategy.',
  },
  searchStrategy_searchDatabase: {
    value: 'Select date to help you find the available version closest to this given date.',
  },
  searchStudies_leverageStudy: {
    value: 'Completed studies can be leveraged by users having the respective license for the database.',
  },
  navigationMenu: {
    value: 'Click on the button to shrink the navigation menu to a smaller menu bar and click again to shrink it back to normal size.',
  },
  businessDescReview_eliminationCriteria: {
    value: 'Click here to add or modify decision criteria.\nA legend of the Decision Criteria is displayed at the bottom of the page.',
  },
  businessDescReview_addColumns: {
    value: 'Selecting this icon will display more available columns',
  },
  businessDescReview_matrixInfo: {
    value: 'Additional columns can be added to this matrix by scrolling to the far right of the screen and selecting the icon with the 3 dots.',
  },
  businessDescReview_companySelectionInfo: {
    value:
      'You can use “bulk accepts”, “bulk rejects” and “add new subset” to facilitate your analysis. Please first select one or multiple companies, scroll down the page and find the buttons below the table.',
  },
  internetReview_thumb_up: {
    value: 'The captured company name matches',
  },
  internetReview_thumb_down: {
    value: 'The captured company name does not match',
  },
  financialReview_compustat_dropdown: {
    value: 'This dropdown menu allows to select different database for Financial Analysis. Selection will be made for all years per company.',
  },
  study_engagementId: {
    value:
      'Enter the engagement code. No upload of file is required. Please provide the engagement code affiliated with the engagement agreement, statement of work, prime sub memorandum, or other arrangement pursuant to which the work is being performed.',
  },
  multi_database_selection_criteria_notification: {
    value: "In order to choose multiple databases, two or more DB's must be selected.",
  },
  adjustment_balancedata_tabs_missing_field: {
    value: 'Please enter missing fields',
  },
  company_drill_down_tab: {
    value: 'Click on the company name to view details in the Company Drill Down tab',
  },
  businessDescReview_review_buttonInfo: {
    value:
      'By checking the “Reviewed” check box you acknowledge the fact that you have verified proposed AI/ML predictions and made appropriate changes.',
  },
};
